import { AdvancerDecliner, Events, ChartIQ, ESASTMomo, ModelOutput, News, Quotes, Tables, TrendModel, WatchBox, WatchBoxItem } from 'components';
import { ActiveRotations, CompleteRotationalModelTrades } from 'components/WatchBox/components';
import { Model } from 'mongoose';

export interface IWidgetItem {
  component: any,
  configProps: string[],
  panelProps: {
    canPopout?: boolean,
    canScroll?: boolean,
    hideHeader?: boolean,
    fontSizeAdjustable?: boolean,
    centerHeader?: boolean,
  },
  phref: string,
  title: string,
}

export interface IWigetItems {
  [key: string]: IWidgetItem
}

export const widgetItems: IWigetItems = {
  activeRotations: {
    component: ActiveRotations,
    configProps: [],
    panelProps: {
      canPopout: true,
      canScroll: true,
    },
    phref: '/rotations/active',
    title: 'Active rotations',
  },
  'advancer-decliner': {
    component: AdvancerDecliner,
    configProps: [],
    panelProps: {
      canPopout: true,
      canScroll: true,
      hideHeader: false,
    },
    phref: '/advancer-decliner',
    title: 'Advancer/Decliner',
  },
  events: {
    component: Events,
    configProps: [],
    panelProps: {
      canPopout: true,
      canScroll: true,
      hideHeader: false,
    },
    phref: '/events',
    title: 'Events',
  },
  chart: {
    component: ChartIQ,
    configProps: ['symbol', 'secondSym'],
    panelProps: {
      canPopout: true,
      canScroll: false,
      hideHeader: false,
    },
    phref: '/chartiq',
    title: 'Chart',
  },
  completedRotations: {
    component: CompleteRotationalModelTrades,
    configProps: [],
    panelProps: {
      canPopout: true,
      canScroll: true,
    },
    phref: '/rotations/pasts',
    title: 'Complete rotations',
  },
  esastamomo: {
    component: ESASTMomo,
    configProps: ['symbol'],
    panelProps: {
      canPopout: true,
      canScroll: true,
      hideHeader: false,
    },
    phref: '/esastmomo',
    title: 'STMomo',
  },
  model: {
    component: Model,
    configProps: [],
    panelProps: {
      canPopout: true,
      canScroll: true,
      hideHeader: false,
    },
    phref: '/model',
    title: 'Model',
  },
  modelOutput: {
    component: ModelOutput,
    configProps: ['symbol'],
    panelProps: {
      canPopout: true,
      canScroll: true,
      hideHeader: false,
    },
    phref: '/modeloutput',
    title: 'Model output',
  },
  news: {
    component: News,
    configProps: [],
    panelProps: {
      canPopout: true,
      canScroll: true,
      hideHeader: false,
    },
    phref: '/news',
    title: 'News',
  },
  quotes: {
    component: Quotes,
    configProps: [],
    panelProps: {
      canPopout: true,
      canScroll: true,
      fontSizeAdjustable: true,
      hideHeader: false,
    },
    phref: '/quotes',
    title: 'Quotes',
  },
  tables: {
    component: Tables,
    configProps: [],
    panelProps: {
      canPopout: true,
      canScroll: true,
      hideHeader: false,
    },
    phref: '/table',
    title: 'Table',
  },
  trendModel: {
    component: TrendModel,
    configProps: [],
    panelProps: {
      canPopout: true,
      canScroll: true,
      hideHeader: false,
    },
    phref: '/trendmodel',
    title: 'Trend Model',
  },
  watchbox: {
    component: WatchBox,
    configProps: [],
    panelProps: {
      canPopout: true,
      canScroll: true,
      hideHeader: false,
    },
    phref: '/watchbox',
    title: 'Watchbox',
  },
  watchboxItem: {
    component: WatchBoxItem,
    configProps: ['symbol', 'websocketKey'],
    panelProps: {
      canPopout: true,
      canScroll: false,
      centerHeader: true,
    },
    phref: '/watchboxitem',
    title: 'WatchBox',
  },
};
